import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import Layout from 'Global/Layout';
import SEO from 'Global/SEO';
import Hero from 'Component/Home/Hero/Hero';
import HomeOverlap from 'Component/Home/HomeOverlap/HomeOverlap';
import InvestmenOptions from 'Component/Home/InvestmentOptions/InvestmenOptions';
import FinancialAdvice from 'Component/Home/FinancialAdvice/FinancialAdvice';
import TwoColumnSection from 'Component/TwoColumnSection/TwoColumnSection';
import News from 'Component/News/News';
import MobileApps from 'Component/Home/MobileApps/MobileApps';

import IconsData from 'IconsData/Home.json';
import TwoColumnData from 'TwoColumnData/Home.json';
import NewsData from 'NewsData/Home.json';

import css from 'Style/pages/home.module.scss';

const Home = () => {
	const images = useStaticQuery(IMAGES_QUERY);

	return (
		<Layout>
			<SEO
				title='Moneyfront: Invest in "Direct" Plans of Mutual fund schemes'
				fullTitle
			/>
			<div className={css.home}>
				<Hero iconsData={IconsData} />
				<HomeOverlap />
				<InvestmenOptions />
				<FinancialAdvice />
				<TwoColumnSection
					data={TwoColumnData}
					images={images}
					btnText="Get Started"
					hideMobile
				/>
				<News heading="Moneyfront in News" data={NewsData} seeAll />
				<MobileApps />
			</div>
		</Layout>
	);
};

const IMAGES_QUERY = graphql`
	{
		internationalInvesting: file(
			relativePath: { eq: "home/two-column/international-investing.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
		corporateTreasury: file(
			relativePath: { eq: "home/two-column/corporate-treasury.png" }
		) {
			childImageSharp {
				fixed(width: 400) {
					...GatsbyImageSharpFixed_withWebp_noBase64
				}
			}
		}
	}
`;

export default Home;
